import { Map, Set } from 'immutable';
import { constants as multiviewGridConstants } from '@saucelabs/sl-component-multiview-grid';

import {
  CLEAR_MOBILE_SELECTION_FILTER,
  LS_MOBILE_SELECTION_CURRENT_VIEW,
  SET_MOBILE_SELECTION_CURRENT_VIEW,
  UPDATE_MOBILE_SELECTION_FILTER,
  UPDATE_MOBILE_SELECTION_SEARCH_TERM,
  MOBILE_SELECTION_FILTER_CATEGORY as FILTER_CATEGORY,
} from './../constants';

const initialState = Map({
  activeFilters: Map({
    [FILTER_CATEGORY.CLOUD_TYPE]: Set([]),
    [FILTER_CATEGORY.FORM_FACTOR]: Set([]),
    [FILTER_CATEGORY.OS]: Set([]),
    [FILTER_CATEGORY.OS_VERSION]: Set([]),
    [FILTER_CATEGORY.MANUFACTURER]: Set([]),
    [FILTER_CATEGORY.NETWORK_TYPE]: Set([]),
    [FILTER_CATEGORY.RESOLUTION]: Set([]),
  }),
  // TODO: Move localStorage access to an operation (during re-ducks refactoring)
  currentView:
    window.localStorage.getItem(LS_MOBILE_SELECTION_CURRENT_VIEW) ||
    multiviewGridConstants.VIEW_TYPE.SMALL_BOX,
  searchTerm: '',
});

const mobileSelectionReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_MOBILE_SELECTION_CURRENT_VIEW:
      // TODO: Move localStorage access to an operation (during re-ducks refactoring)
      window.localStorage.setItem(LS_MOBILE_SELECTION_CURRENT_VIEW, payload);
      return state.set('currentView', payload);
    case UPDATE_MOBILE_SELECTION_FILTER: {
      const { category, filter } = payload;
      const filterAlreadyActive = state.hasIn(['activeFilters', category, filter]);
      return state.setIn(
        ['activeFilters', category],
        state.getIn(['activeFilters', category])[filterAlreadyActive ? 'subtract' : 'union']([filter]),
      );
    }
    case CLEAR_MOBILE_SELECTION_FILTER:
      return state.set('activeFilters', initialState.get('activeFilters'));
    case UPDATE_MOBILE_SELECTION_SEARCH_TERM:
      return state.set('searchTerm', payload.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1'));

    default:
      return state;
  }
};

export default mobileSelectionReducer;
export { initialState };
